/**
 * Branding Configuration
 *
 * This file contains all branding-related settings that can be easily changed
 * to rebrand the application for different companies.
 *
 * To rebrand:
 * 1. Replace the logo file in src/assets/logo.svg with your company logo
 * 2. Update the companyName below
 * 3. Update other settings as needed
 */

export const branding = {
  // Company name used throughout the application
  companyName: '',

  // Path to the company logo (relative to src/assets/)
  logoPath: '',

  // Alternative text for the logo (for accessibility)
  logoAlt: '',

  // Application title (used in browser tab, meta tags, etc.)
  appTitle: 'Dashboard',

  // Copyright text in footer
  get copyrightText() {
    const year = new Date().getFullYear();
    return `© ${year} All rights reserved.`;
  },
} as const;

// Helper function to get the full logo import
export const getLogoImport = () => branding.logoPath;

// Helper function to get company name
export const getCompanyName = () => branding.companyName;

// Helper function to get app title
export const getAppTitle = () => branding.appTitle;
